export class SystemEinstellung<T> {
    public value: T;

    constructor(value: T) {
        this.value = value;
    }

    public isEnabled(): boolean {
        return typeof this.value === 'string'
            ? this.value === 'j'
            : Boolean(this.value);
    }

    public isDisabled(): boolean {
        return typeof this.value === 'string'
            ? this.value === 'n'
            : Boolean(this.value);
    }

    public toString(): string {
        return String(this.value);
    }

    public eq(value: T): boolean {
        return this.value === value;
    }

    public noteq(value: T): boolean {
        return this.value !== value;
    }
}

export interface SystemEinstellungen {
    befundwert_numerisch: string;
    brief_ortsname: string;
    cbird_vorhanden: string;
    dekurse_anzeigen: string;
    eimpfpass_adresse_uebernehmen: string;
    einsendeformular: string;
    fusszeilen_drucken: string;
    kartei_gruppierung: string;
    kartei_tageseintrag: string;
    kopf_drucken: string;
    kopfzeilen_grafik: string;
    kopfzeilen_grafik_groesse: string;
    kopfzeilen_variante: string;
    modul_briefe: string;
    modul_impferinnerungen: string;
    modul_rezepte: string;
    modul_terminkalender: string;
    patient_folgetermin: string;
    rechnung_berichtigt: string;
    rechnung_geplantes: string;
    rechnung_xml_export: string;
    rechnungsdruck_doppelt: string;
    rezeptdrucker: string;
    system_termine: string;
    untersuchungsanforderung_aktiv: string;
    zahlungseingang: string;
    rolle_anwender_reduziert: string;
    fibu_variante: string;
    rezeptformular: string;
    untersuchungsanforderung: string;
    untersuchungsanforderungvariante: string;
    etikettvariante: string;
    warteliste_remove_kassaabschluss: string;
    kassaabschluss_aufschluesselung: string;
    muw: string;
    warteliste_umschaltbar: string;
    druckvariante: string;
    terminserien: string;
    impfetiketten_druck: string;
    impfetiketten_drucker: string;
    terminerinnerung_in_x_tagen: string;
    rechnung_drucken_und_abschliessen: string;
    abfrage_wieder_auf_warteliste: string;
    default_impfsetting: string;
}

export type SystemEinstellungKey = keyof SystemEinstellungen;

export default class Einstellung {
    /** PK: Einstellung | max. 50 Zeichen | erforderlich **/
    public einstellung: string | null = null;
    /**  | max. 255 Zeichen | erforderlich **/
    public wert: string | null = null;

    public prevEinstellung: string | null = null;

    constructor(data?: Partial<Einstellung>) {
        Object.assign(this, data);
    }
}
